import React from "react";
import { Helmet } from "react-helmet";
import { ConfirmActionModal } from "@src/common/components/Modal/ConfirmActionModal/ConfirmActionModal";
import { ModalVideoPlayer } from "@src/client/components/ModalVideoPlayer/ModalVideoPlayer";
import { DrawerUploadVideoMenu } from "@src/client/components/DrawerUploadVideoMenu/DrawerUploadVideoMenu";
import { useStores } from "@client/store";
import { GlobalLoader } from "@src/common/components/GlobalLoader/GlobalLoader";
import { observer } from "mobx-react-lite";
import { TableBlock } from "@src/common/components/TableBlock/TableBlock";
import { NoticeNotAvailableAction } from "@src/common/components/Notice/NoticeNotAvailableAction/NoticeNotAvailableAction";
import { VideoUploadErrorModal } from "@common/components/ModalVideoUploadError/VideoUploadErrorModal";
import { useNavigate } from "react-router-dom";
import { Header } from "./Header/Header";
import { HomeContainer } from "./Home.styled";
import { InitialDialog } from "./InitialDialog/InitialDialog";

export const HomePage = observer(() => {
  const {
    client: {
      authStore: { isFetching },
      infeedTableStore: {
        campaigns,
        tab,
        tabCounts,
        sortOrder,
        sortField,
        tableColumns,
        totalRowsCount,
        fetchTabCounts,
        fetchCampaigns,
        onChangeSort: handleChangeSort,
        onChangePagination: handleChangePagination,
        setTab: handleSetTab,
        getTabCount,
      },
      notAvailableActionNotice,
      uploadAreaStore: { loadingProgress, detach: uploadAreaDetach },
    },
    uploadAreaErrorModal,
    exitModalStore,
  } = useStores();

  const navigate = useNavigate();

  const handleRowClick = (uuid) => {
    navigate(`/${uuid}`);
  };

  return (
    <>
      <Helmet>
        <title>Рекламный кабинет</title>
      </Helmet>
      <Header />

      <HomeContainer>
        <TableBlock
          campaigns={campaigns}
          tab={tab}
          tabCounts={tabCounts}
          sortOrder={sortOrder}
          sortField={sortField}
          tableColumns={tableColumns}
          totalRowsCount={totalRowsCount}
          isFetching={isFetching}
          onChangeSort={handleChangeSort}
          onChangePagination={handleChangePagination}
          fetchTabCounts={fetchTabCounts}
          fetchCampaigns={fetchCampaigns}
          onRowClick={handleRowClick}
          onSetTab={handleSetTab}
          getTabCount={getTabCount}
        />
      </HomeContainer>

      <VideoUploadErrorModal uploadAreaErrorModalStore={uploadAreaErrorModal} />
      <InitialDialog />
      <NoticeNotAvailableAction
        isOpen={notAvailableActionNotice.isOpen}
        // eslint-disable-next-line react/jsx-handler-names
        onCloseDialog={notAvailableActionNotice.closeDialog}
      />
      <ConfirmActionModal exitModalStore={exitModalStore} />
      <ModalVideoPlayer />
      <DrawerUploadVideoMenu uploadAreaDetach={uploadAreaDetach} />
      <GlobalLoader progress={loadingProgress} />
    </>
  );
});
